import React from 'react'
import { range } from 'libraries/lodash'
import PaginationItem from 'components/search/PaginationItem'

const Pagination = (props) => {
  const { total, pageLength } = props
  const itemRange = range(1, 1 + Math.ceil(total / pageLength))

  return (
    <div className='flex items-center'>
      {itemRange.length > 1 && <span className='mr4 f6-m'>Go to page</span>}
      <PaginationList {...{ itemRange, ...props }} />
    </div>
  )
}

const PaginationList = ({ total, page: pageNumber, pageLength, getUrl, itemRange }) => (total <= pageLength)
  ? null
  : (
    <ul className='flex bt bl bb b--phantom-grey br1 list-reset pa0'>
      {itemRange.map(page => (
        <PaginationItem
          key={page}
          link={getUrl(page)}
          {...{ page, pageNumber }}
        />
      ))}
    </ul>
    )

export default Pagination
